/* eslint-disable no-plusplus */
import { SaltDocument } from '../SaltDocument';

const barcodeTemplate = require('./barcode_simple');

class BarcodeTranspiler {
    generateSalt(dialog) {
        const document = new SaltDocument(barcodeTemplate);
        const viewEl = document.getByExpr('**.view');
        document.singleSelectNode(viewEl);
        // @TODO alias, viewAlias - we may want to allow salt to also reference user defined aliases
        const { view } = dialog;
        const viewId = SaltDocument.getViewId(view);
        document.setAttribute('id', viewId);
        return document.rootNode;
    }
}

const barcodeTranspiler = new BarcodeTranspiler();
export default barcodeTranspiler;
